import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { useColorScheme, useTheme } from '@mui/material/styles';

import { useIntl } from 'react-intl';

import { IconMoon, IconSun } from '@tabler/icons-react';
import { ThemeMode } from 'config';

/**
 * Header light/dark theme switcher. Replaces the Berry "Live Customize" drawer —
 * we kept only the day/night toggle from that panel and moved it inline.
 */
export default function ThemeModeToggle() {
  const theme = useTheme();
  const intl = useIntl();
  const { mode, setMode } = useColorScheme();
  const isDark = mode === ThemeMode.DARK;

  const handleToggle = () => setMode(isDark ? ThemeMode.LIGHT : ThemeMode.DARK);

  const tooltip = intl.formatMessage({
    id: isDark ? 'header.theme.light' : 'header.theme.dark',
    defaultMessage: isDark ? 'Világos téma' : 'Sötét téma'
  });
  const ariaLabel = intl.formatMessage({
    id: isDark ? 'header.theme.toLight' : 'header.theme.toDark',
    defaultMessage: isDark ? 'Világos témára váltás' : 'Sötét témára váltás'
  });

  return (
    <Box sx={{ ml: 1, mr: 1, display: { xs: 'none', sm: 'block' } }}>
      <Tooltip title={tooltip}>
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            transition: 'all .2s ease-in-out',
            color: theme.vars?.palette?.secondary?.dark,
            background: theme.vars?.palette?.secondary?.light,
            cursor: 'pointer'
          }}
          onClick={handleToggle}
          aria-label={ariaLabel}
        >
          {isDark ? <IconSun stroke={1.5} size="20px" /> : <IconMoon stroke={1.5} size="20px" />}
        </Avatar>
      </Tooltip>
    </Box>
  );
}
